/**
 * vet-visit-drawer.js
 */

import React from 'react';
import { 
  useRouteMatch,
  useLocation,
  useHistory,
  matchPath,
} from "react-router-dom";
import { Types } from 'utils/constants';
import { paths } from 'utils/routing';
import MenuDrawer from 'components/menu-drawer';
import VetVisitEdit from '../drawer/vet-visit-edit';
import VetVisitMenu from '../menu/vet-visit-menu';
import VetVisitView from '../drawer/vet-visit-view';



export default function VetVisitDrawer(props) {
  let location = useLocation();
  let history = useHistory();
  let basePath = useRouteMatch();
  const [params, setParams] = React.useState({});
  const drawerBasePath = basePath.url + paths.vetVisit.base;


  // MENU ROUTES
  const menuRoutes = [{
    component: VetVisitMenu,
    path: [
      drawerBasePath + paths.vetVisit.pattern
    ]
  }];


  // CONTENT ROUTES
  const routes = [{
    component: VetVisitEdit,
    path: [
      drawerBasePath + paths.vetVisit.edit.path
    ],
  }, {
    component: VetVisitView,
    path: [
      drawerBasePath + paths.vetVisit.view.path
    ],
  }];

  
  const onCloseLocal = () => {
    history.push(basePath.url);
  }


  React.useEffect(() => {
    const defaultMatch = matchPath(
      location.pathname,
      drawerBasePath + paths.vetVisit.pattern
    );

    const newParams = defaultMatch?.params;

    if (newParams?.id !== undefined) {
      newParams.id = parseInt(newParams.id);
    }
    if (newParams?.step !== undefined) {
      newParams.step = parseInt(newParams.step);
    }

    setParams(newParams);

  }, [location, drawerBasePath]);


  return (
    <>
      {basePath &&
      <MenuDrawer
        drawerPath={paths.vetVisit.base}
        basePath={basePath.url}
        menuRoutes={menuRoutes}
        desktopRoutes={routes}
        mobileRoutes={routes}
        onClose={onCloseLocal}
        params={params}
        title='VET VISIT'
        recordGroupType={Types.RecordGroup.VET_VISIT}
      />}
    </>
  );
}